import React from 'react'
import PropTypes from 'prop-types'
import { create, all } from 'mathjs'

import { Updaters } from '@leverege/api-attributes'
import Util from './Util'
import { TextInput, NumericInput, LabelGroup, Flex } from '~/views'

const mathjs = create( all )
// mathjs.import( require( 'mathjs/lib/expression/parse' ) )

export default class FunctionEditor extends React.Component {

  static TYPE = Updaters.FunctionUpdaterCreator.typeName();

  static propTypes = {
    updater : PropTypes.object,
    attribute : PropTypes.object,
    blueprint : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.changePath = Util.ChangePath.bind( this )
  }

  render() {
    const { updater } = this.props
    if ( updater == null ) {
      return <div />
    }

    return (
      <Flex variant="vSpace" direction="column" align="flex-start">
        
        <LabelGroup>
          <label>Equation</label>
          <TextInput
            hint="Description..."
            value={updater.function}
            changeOnReturn 
            validator={validator}
            style={{ width : '100%' }}
            onChange={( v, err ) => { this.changePath( 'function', v, err ) }} />
        </LabelGroup>

        <LabelGroup>
          <label>Every</label>
          <div>
            <NumericInput
              hint="Seconds..." 
              value={updater.update / 1000}
              float
              size={5}
              min={0}
              onChange={( v, err ) => { this.changePath( 'update', typeof v === 'number' ? v * 1000 : v, err ) }} />
            <label style={{ padding : '0 8px' }}>seconds</label>
          </div>
        </LabelGroup>
      </Flex>
    ) 
  }
}

function validator( val ) {
  if ( val == null || val == '' ) {
    return true;
  }
  try {
    const p = mathjs.parse( val )
    if ( p == null ) {
      return false
    }
    const c = p.compile( )
    if ( c == null ) {
      return false
    }
    return true
  } catch ( err ) {
    console.log( err )
  }
  return false
}
